import { apiFetch } from './client'

export type Platform = 'Instagram' | 'Facebook' | 'YouTube' | 'TikTok'
export type SocialAccountStatus =
  | 'Connected'
  | 'TokenExpired'
  | 'RequiresReauth'
  | 'Revoked'
  | 'Disconnected'

export interface ConnectedAccount {
  id: string
  platform: Platform
  accountName: string
  externalAccountId: string
  status: SocialAccountStatus
  accessTokenExpiresAt: string | null
  scopes: string
}

export interface StartConnectResponse {
  authorizationUrl: string
}

export const socialAccountsApi = {
  list: () => apiFetch<ConnectedAccount[]>('/api/oauth/accounts'),

  connectGoogle: () =>
    apiFetch<StartConnectResponse>('/api/oauth/google/connect', { method: 'POST' }),

  disconnectGoogle: (id: string) =>
    apiFetch<void>(`/api/oauth/google/disconnect/${id}`, { method: 'POST' }),

  connectMeta: () =>
    apiFetch<StartConnectResponse>('/api/oauth/meta/connect', { method: 'POST' }),

  disconnectMeta: (id: string) =>
    apiFetch<void>(`/api/oauth/meta/disconnect/${id}`, { method: 'POST' }),

  connectTikTok: () =>
    apiFetch<StartConnectResponse>('/api/oauth/tiktok/connect', { method: 'POST' }),

  disconnectTikTok: (id: string) =>
    apiFetch<void>(`/api/oauth/tiktok/disconnect/${id}`, { method: 'POST' }),
}
